export const DEFAULT_OPTION_ID = 'default';
export const TIME_SLOTS_MAX_RESULT = 300;

const FULFILLER_REGION_MAP: Record<string, string> = {
  AU: 'SG',
  BR: 'US',
  CA: 'US',
  CL: 'US',
  CO: 'US',
  HK: 'SG',
  MX: 'US',
  SG: 'SG',
  TW: 'SG',
};

const MERCHANT_ID_CONFIG: Record<string, string> = {
  AT: process.env.ONEFF_MERCHANT_ID_AT ?? '',
  AU: process.env.ONEFF_MERCHANT_ID_AU ?? '',
  BE: process.env.ONEFF_MERCHANT_ID_BE ?? '',
  BR: process.env.ONEFF_MERCHANT_ID_BR ?? '',
  CA: process.env.ONEFF_MERCHANT_ID_CA ?? '',
  CH: process.env.ONEFF_MERCHANT_ID_CH ?? '',
  CL: process.env.ONEFF_MERCHANT_ID_CL ?? '',
  CO: process.env.ONEFF_MERCHANT_ID_CO ?? '',
  CZ: process.env.ONEFF_MERCHANT_ID_CZ ?? '',
  DE: process.env.ONEFF_MERCHANT_ID_DE ?? '',
  DZ: process.env.ONEFF_MERCHANT_ID_DZ ?? '',
  EE: process.env.ONEFF_MERCHANT_ID_EE ?? '',
  EG: process.env.ONEFF_MERCHANT_ID_EG ?? '',
  ES: process.env.ONEFF_MERCHANT_ID_ES ?? '',
  FR: process.env.ONEFF_MERCHANT_ID_FR ?? '',
  GF: process.env.ONEFF_MERCHANT_ID_GF ?? '',
  GP: process.env.ONEFF_MERCHANT_ID_GP ?? '',
  GB: process.env.ONEFF_MERCHANT_ID_GB ?? '',
  HR: process.env.ONEFF_MERCHANT_ID_HR ?? '',
  HU: process.env.ONEFF_MERCHANT_ID_HU ?? '',
  HK: process.env.ONEFF_MERCHANT_ID_HK ?? '',
  IE: process.env.ONEFF_MERCHANT_ID_IE ?? '',
  IT: process.env.ONEFF_MERCHANT_ID_IT ?? '',
  LT: process.env.ONEFF_MERCHANT_ID_LT ?? '',
  LU: process.env.ONEFF_MERCHANT_ID_LU ?? '',
  LV: process.env.ONEFF_MERCHANT_ID_LV ?? '',
  MA: process.env.ONEFF_MERCHANT_ID_MA ?? '',
  MQ: process.env.ONEFF_MERCHANT_ID_MQ ?? '',
  MX: process.env.ONEFF_MERCHANT_ID_MX ?? '',
  NL: process.env.ONEFF_MERCHANT_ID_NL ?? '',
  PL: process.env.ONEFF_MERCHANT_ID_PL ?? '',
  PT: process.env.ONEFF_MERCHANT_ID_PT ?? '',
  RE: process.env.ONEFF_MERCHANT_ID_RE ?? '',
  RO: process.env.ONEFF_MERCHANT_ID_RO ?? '',
  RS: process.env.ONEFF_MERCHANT_ID_RS ?? '',
  SG: process.env.ONEFF_MERCHANT_ID_SG ?? '',
  SI: process.env.ONEFF_MERCHANT_ID_SI ?? '',
  SK: process.env.ONEFF_MERCHANT_ID_SK ?? '',
  TR: process.env.ONEFF_MERCHANT_ID_TR ?? '',
};

const invertConfig = (obj: Record<string, string>): Record<string, string> => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, value]) => !!value)
      .map(([key, value]) => [value, key]),
  );
};

const COUNTRY_BY_MERCHANT_ID = invertConfig(MERCHANT_ID_CONFIG);

export const getMerchantId = (country: string): string => {
  return MERCHANT_ID_CONFIG[country?.toUpperCase()] ?? '';
};

export const getCountryByMerchantId = (
  merchantId?: string,
): string | undefined => {
  // Disable in development, we have the same merchant id
  if (!merchantId || process.env.NODE_ENV === 'development') {
    return undefined;
  }
  return COUNTRY_BY_MERCHANT_ID[merchantId];
};

export const getFulfillerId = (country: string): string => {
  const normalizedCountry = country?.toUpperCase();
  const region = FULFILLER_REGION_MAP[normalizedCountry] || 'EU';

  const fulfillerEnv: Record<string, string | undefined> = {
    SG: process.env.ONEFF_FULFILLER_ID_SG,
    US: process.env.ONEFF_FULFILLER_ID_US,
    EU: process.env.ONEFF_FULFILLER_ID_EU,
  };

  return fulfillerEnv[region] ?? '';
};
